<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader @click="collapse = !collapse">
            <strong>{{ $t('components.addDriver') }}</strong>
          </CCardHeader>
       <CCollapse :show="collapse">
          <CCardBody>
              <CRow>
                <CCol col="4">

                  <treeselect
                      v-model="document_person"

                      :async="true"
                      :load-options="load_persons"
                      :placeholder="$t('components.searchUser')"
                      :normalizer="normalizer_persons"
                  />

                </CCol>
              </CRow>
              <br>
              <CRow>

                <CCol>
                  <CSelect
                      :value.sync=car_type
                      :options="car_type_items"
                      :label="$t('components.vehicleType')"
                  />

                </CCol>
                <CCol>
                  <CSelect
                      :value.sync=car_name
                      :options="car_name_items"
                      :label="$t('components.vehicle')"
                  />

                </CCol>
                <CCol>

                  <CInput
                      :label="$t('components.licensePlate')"
                      v-model="car_pelak"
                  />
                </CCol>
                <CCol>

                  <CInput
                      :label="$t('components.maximumWeight')"
                      type="number"
                      v-on:keypress="isNumber($event)"
                      v-model="mizan_bar"
                  />
                </CCol>
              </CRow>


          </CCardBody>

          <CCardFooter>
            <CButton v-if="status_form==0" @click="insert_data()" type="submit" size="sm" color="primary">
              <CIcon name="cil-check-circle"/>
              {{ $t('buttons.addUser') }}
            </CButton>
            <CButton v-if="status_form==0" @click="emptyList()" type="reset" size="sm" color="danger">
              <CIcon name="cil-ban"/>
              {{ $t('buttons.emptyForm') }}
            </CButton>
            <CButton v-if="status_form!=0" @click="emptyList()" type="reset" size="sm" color="danger">
              <CIcon name="cil-ban"/>
              {{ $t("buttons.cancel") }}
            </CButton>
          </CCardFooter>
       </CCollapse>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <strong>{{ $t('components.driversList') }}</strong>
          </CCardHeader>
          <CCardBody>
            <CDataTable
                :items="items"
                :fields="fields"

                :items-per-page="20"
                hover
                sorter
                pagination
            >
              <template v-slot:[item_row_name]="{item}">

                <td>
                  <p >{{item.row_id+1}}</p>

                </td>

              </template>
              <template #user="{item}">

                <td>
                  <p >{{ item.personName }}</p>

                </td>

              </template>


              <template #vehicle="{item}">

                <td>
                  <p >{{ item.carType }} {{ item.carName }}</p>

                </td>

              </template>

              <template #tag="{item}">

                <td>
                  <p >{{ item.carPelak }}</p>

                </td>

              </template>

              <template #weight="{item}">

                <td>
                  <p >{{ item.mizanBar }} {{ $t('components.weightUnit') }}</p>

                </td>

              </template>


              <template #operation="{item}">
                <td >

                  <CButton
                      color="danger"
                      variant="outline"
                      square
                      size="sm"
                      @click="delete_item_dialog(item)"
                  >{{ $t('buttons.delete') }}
                  </CButton>
                  <CButton
                      color="primary"
                      variant="outline"
                      square
                      size="sm"
                      @click="goSubCategories(item)"
                  >{{ $t('buttons.refersDocuments') }}
                  </CButton>
                  <CButton
                      color="primary"
                      variant="outline"
                      square
                      size="sm"
                      @click="goReturnDocuments(item)"
                  >{{ $t('components.temporaryReturnDocuments') }}
                  </CButton>
                </td>
              </template>


            </CDataTable>
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
var items = [];


export default {
  name: 'Login',
  components: {
    Treeselect,

  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
      collapse:false,
      validate_errors: [],
      person_name: '',
      person_mobile: '',
      car_pelak: '',
      car_type: 0,
      car_name: 0,
      mizan_bar: '',
item_row_name:'row',
      file: '',
      color: '#ffffff',
      previewImage: '',
      description: '',
      items: items.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row', label: this.$t('tables.row'), _style: 'width:10%'},
        {key: 'user', label: this.$t('tables.user'), _style: 'width:10%'},
        {key: 'vehicle', label: this.$t('tables.vehicle'), _style: 'width:10%'},
        {key: 'tag', label: this.$t('tables.tag'), _style: 'width:10%'},
        {key: 'weight', label: this.$t('tables.weight'), _style: 'width:10%'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},


      ],

      car_type_items: [],

      car_name_items: [],


      document_person: null,

      details: [],
      collapseDuration: 0,
      status_form: 0,
      load_persons({action, searchQuery, callback}) {
        var self = this;

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);

            axios.post('GetUsers', formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
        }
      },

    }
  },
  created() {
  },
  mounted() {
    this.$root.root_validate_errors = [];
    this.get_car_names();
    this.get_car_types();

    this.get_lists();
    // this.get_provinces();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'document_person': function () {
      this.get_user_data();
    },

  },
  methods: {
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.document_person != '' && this.car_type != 0 && this.car_name != 0 && this.car_pelak != ''
          && this.mizan_bar != '') {
        return true;
      }


      if (this.document_person == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }
      if (this.car_type == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectVehicleType'));
      }
      if (this.car_name == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectVehicle'));
      }
      if (this.car_pelak == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertLicensePlate'));
      }
      if (this.mizan_bar == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertMaximumWeight'));
      }

      return false;
      // e.preventDefault();
    },

    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = this.items[item.row_id].areaName;
      this.selected_province = this.items[item.row_id].provinceId;
      this.selected_city = this.items[item.row_id].cityId;
      this.get_cities();
      this.polygon_area = JSON.parse(this.items[item.row_id].areaRange);
      this.show_polygon();

      this.status_form = this.items[item.row_id].id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_lists() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetDistributors', formData, {
        params: {
          // isparent : self.$route.params.cat_id
        },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_car_types() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetCarTypes', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.car_type_items = [];

          content_data.data.forEach((val) => {
            var obj = {label: val.typeTitle, value: val.id}

            self.car_type_items.push(obj);
          });
self.car_type = self.car_type_items[0].value
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_car_names() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetCarNames', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.car_name_items = [];
          content_data.data.forEach((val) => {
            var obj = {label: val.name, value: val.id}

            self.car_name_items.push(obj);
          });
          self.car_name = self.car_name_items[0].value

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goSubCategories(item) {

      this.$router.push({path: '/dashboard/delivery/driver-documents/' + item.personId});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    }, goReturnDocuments(item) {

      this.$router.push({path: '/dashboard/delivery/driver-return-documents/' + item.personId});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },

    get_user_data() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.document_person);


      axios.post('GetPersonById', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.person_mobile = content_data.data.mobileNo;
          self.person_name = content_data.data.personName;
          // self.province_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    insert_data() {

      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddDistributor";
      } else {
        url = "EditDistributor";
        formData.append('id', this.status_form)

      }


      formData.append('PersonId', this.document_person);
      formData.append('PersonName', this.person_name);
      formData.append('MobileNo', this.person_mobile);
      formData.append('CarPelak', this.car_pelak);
      formData.append('CarType', this.car_type);
      formData.append('CarName', this.car_name);
      formData.append('MizanBar', this.mizan_bar);
      formData.append('AreaId', this.selected_area);
      axios.post(url, formData, {}).then((res) => {



        self.status_form = 0;
        self.name = '';
        self.color = '';
        self.description = '';
        self.previewImage = '';
        self.get_lists();

        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {

      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessageParams", [item.user]), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteDistributor";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
